import http from '../http'

/**
 * 获取客户端值
 * @param access
 * @returns {*}
 */
export function getAttributesClient(access) {
  return http({
    url: '/api/v1/' + access + '/attributes',
    method: 'get',
    urlType: 'meteSoil'
  })
}

/**
 * 发送客户端值数据
 * @param access
 * @returns {*}
 */
export function postAttributesClient(access, param) {
  return http({
    url: '/api/v1/' + access + '/attributes',
    method: 'post',
    data: param,
    urlType: 'meteSoil'
  })
}

/**
 * 获取服务端值
 * @param entityType
 * @param deviceId
 * @returns {AxiosPromise}
 */
export function getAttributesServer(entityType, deviceId) {
  return http({
    url: '/api/plugins/telemetry/' + entityType + '/' + deviceId + '/values/attributes/SERVER_SCOPE',
    method: 'get',
    urlType: 'meteSoil'
  })
}

/**
 * 获取共享端值
 * @param entityType
 * @param deviceId
 * @returns {AxiosPromise}
 */
export function getAttributesShared(entityType, deviceId) {
  return http({
    url: '/api/plugins/telemetry/' + entityType + '/' + deviceId + '/values/attributes/SHARED_SCOPE',
    method: 'get',
    urlType: 'meteSoil'
  })
}

/**
 * 管理员用户获取设备
 * @returns {AxiosPromise}
 */
export function getDevicesInfo() {
  return http({
    // url: '/api/tenant/dashboards?limit=100',
    url: '/api/tenant/devices?limit=10000',
    method: 'get',
    urlType: 'meteSoil'
  })
}

/**
 * 普通用户获取设备
 * @param customerId
 * @returns {AxiosPromise}
 */
export function getCustomerDevice(customerId) {
  return http({
    url: '/api/customer/' + customerId + '/' + 'devices?limit=1000',
    method: 'get',
    urlType: 'meteSoil'
  })
}

/**
 * 获取设备类型
 * @param entityId
 * @returns {AxiosPromise}
 */
export function getCredentials(entityId) {
  return http({
    url: '/api/device/' + entityId + '/credentials',
    method: 'get',
    urlType: 'meteSoil'
  })
}

/**
 * 获取遥测数据的key值
 * @param entityType
 * @param id
 * @returns {AxiosPromise}
 */
export function getDeviceKey(entityType, id) {
  return http({
    url: '/api/plugins/telemetry/' + entityType + '/' + id + '/keys/timeseries',
    method: 'get',
    urlType: 'meteSoil'
  })
}

/**
 * 获取最新遥测数据
 * @param entityType
 * @param id
 * @param key
 * @returns {AxiosPromise}
 */
export function getDeviceValue(entityType, id, key) {
  return http({
    url: '/api/plugins/telemetry/' + entityType + '/' + id + '/values/timeseries?keys=' + key,
    method: 'get',
    urlType: 'meteSoil'
  })
}

/**
 * 获取最后一次连接数据
 * @param entityType
 * @param deviceId
 * @returns {AxiosPromise}
 */
export function getConnectTime(entityType, deviceId) {
  return http({
    url: '/api/plugins/telemetry/'+ entityType + '/' + deviceId + '/values/attributes/SERVER_SCOPE?keys=lastActivityTime',
    method: 'get',
    urlType: 'meteSoil'
  })
}

/**
 * 获取属性历史数据
 * @param entityType
 * @param id
 * @param key
 * @param start
 * @param end
 * @param interval
 * @param agg
 * @returns {*}
 */
export function getTimeDeviceHistory(entityType, id, key, start, end, interval, agg) {
  return http({
    url: '/api/plugins/telemetry/' + entityType + '/' + id + '/values/timeseries?keys=' + key + '&startTs=' + start + '&endTs=' + end + '&interval=' + interval + '&limit=1440&agg=' + agg,
    method: 'get',
    urlType: 'meteSoil'
  })
}





// WEBPACK FOOTER //
// ./src/until/api/MeteSoil.js